<template>
  <div>
    <tk-flex middle class="-translate-y-full" style="display: inline-flex;">
      <span class='m-r-10'>当前时间</span> <DateSelect v-model="time1" />
      <span class='m-r-10 m-l-15'>对比时间</span> <DateSelect v-model="time2" />
    </tk-flex>
    <tk-flex
      v-if="isEmpty"
      class="width-full"
      style="height: 500px"
      middle
      center
    >
      <a-empty></a-empty>
    </tk-flex>
    <div v-else>
      <div
        class="height-full grid bg-white p-x-15 bg-white items-center"
        style="height: 60px; grid-template-columns: 1fr auto 1fr; gap: 15px; transform: translateY(-10px);"
      >
        <div class="font-bold font-16">粮虫数据对比</div>
        <tk-flex class="tabs">
          <div>
            <div
              @click="changeTab(0)"
              class="m-r-10 cursor-pointer"
              :class="tab === 0 ? 'active' : ''"
            >
              汇总
            </div>
          </div>
          <div>
            <div
              class="cursor-pointer"
              @click="changeTab(1)"
              :class="tab === 1 ? 'active' : ''"
            >
              报表
            </div>
          </div>
        </tk-flex>
        <div class="justify-self-end">
          <a-button v-if="tab === 1" type="primary" @click="print"
            >打印</a-button
          >
        </div>
      </div>
      <a-card
        :loading="isRequestPoint || isRequestStore"
        style="transform: translateY(-10px); padding: 0; background-color: #fff;"
      >
        <div v-if="tab === 0" style="padding: 15px">
          <tk-flex
            style="height: 60px; background-color: #F8F9FA; border:1px solid #eee; font-weight: 600; font-size: 16;"
            middle
            center
            >粮虫汇总数据对比</tk-flex
          >
          <div class="flex custom-table">
            <div class="title table-left">
              <div class="title">粮虫种类</div>
              <div>数量（只）</div>
              <div>密度（只/平米）</div>
            </div>
            <div class="flex flex-1 table-right">
              <div class="flex-1">
                <div class="title">象甲科</div>
                <div>--</div>
                <div>--</div>
              </div>
              <div class="flex-1">
                <div class="title">拟步甲科</div>
                <div>--</div>
                <div>--</div>
              </div>
              <div class="flex-1">
                <div class="title">飞蚁科</div>
                <div>--</div>
                <div>--</div>
              </div>
              <div class="flex-1">
                <div class="title">飞蛾科</div>
                <div>--</div>
                <div>--</div>
              </div>
              <div class="flex-1">
                <div class="title">飞蛾幼虫类</div>
                <div>--</div>
                <div>--</div>
              </div>
              <div class="flex-1">
                <div class="title">书虱</div>
                <div>--</div>
                <div>--</div>
              </div>
              <div class="flex-1">
                <div class="title">其他害虫</div>
                <div>--</div>
                <div>--</div>
              </div>
              <div class="flex-1">
                <div class="title">总计</div>
                <div>{{ storeNumShow }}</div>
                <div>--</div>
              </div>
            </div>
          </div>
          <tk-flex
            class="m-t-15"
            style="height: 60px; background-color: #F8F9FA; border:1px solid #eee; font-weight: 600; font-size: 16;"
            middle
            center
            >粮虫监测点位图对比（只）</tk-flex
          >
          <ReportForms
            :storeBugNum="storeNumShow"
            :originalList="originalList"
            :isShowTop="false"
            :isShowTips="false"
            :time1="formatTimeShow(time1Store ? time1Store.date : undefined)"
            :time2="formatTimeShow(time2Store ? time2Store.date : undefined)"
          />
        </div>
        <div v-else>
          <tk-flex center style="padding: 15px">
            <div style="width: 950px;">
              <ReportForms
                ref="print"
                :storeBugNum="storeNumShow"
                :originalList="originalList"
                :isCompared="true"
                :isShowPrint="false"
                :time1="
                  formatTimeShow(time1Store ? time1Store.date : undefined)
                "
                :time2="
                  formatTimeShow(time2Store ? time2Store.date : undefined)
                "
              >
                <tk-flex class="width-full" center>
                  <div class="overflow-hidden" style="width: 60%">
                    <a-card
                      :loading="isRequestPoint"
                      size="small"
                      :bordered="false"
                      style="height: 100%;"
                    >
                      <div class="bg-white">
                        <tk-flex
                          around
                          middle
                          class="height-full grid bg-white p-x-15 bg-white items-center"
                          style="height: 60px; grid-template-columns: 1fr auto 1fr; gap: 15px"
                        >
                          <div style="font-weight: 600;font-size:16px;">
                            粮虫检测点位图
                          </div>
                        </tk-flex>
                        <div>
                          <PointsList
                            :canClassification="false"
                            :canPopUp="false"
                            :horizontal="width"
                            :vertical="height"
                            :isCircle="isCircle"
                            :eqPoints="eqPoints"
                            :diameter="isCircle ? storeInfo.diameter : 0"
                          />
                        </div>
                      </div>
                    </a-card>
                  </div>
                </tk-flex>
              </ReportForms>
            </div>
          </tk-flex>
        </div>
      </a-card>
    </div>
  </div>
</template>
<script>
import ReportForms from './reportForms.vue'
import PointsList from './points'
import moment from 'moment'
import DateSelect from './dateSelect'
const squareRoot2 = 1.414
export default {
  props: {
    lasteTimeTag: {
      type: String,
      default: ''
    },
    date: {
      type: Object,
      required: true
    },
    storeInfo: {
      type: Object,
      required: true
    },
    eqPoints: {
      type: Array,
      required: true
    },
    equipments: {
      type: Array,
      required: true
    },
    allPonits: {
      type: Array,
      required: true
    }
  },
  components: {
    DateSelect,
    ReportForms,
    PointsList
  },
  data () {
    return {
      time1BugNum: 0,
      time2BugNum: 0,
      time1Store: undefined,
      time2Store: undefined,
      isRequestStore: true,
      time1: moment(this.date),
      time2: moment(this.date).subtract(1, 'days'),
      isRequestPoint: true,
      time1points: [],
      time2points: [],
      tab: 0
    }
  },
  created () {
    this.getData()
  },
  watch: {
    time1 (newV) {
      if (newV) {
        this.getData()
      }
    },
    time2 (newV) {
      if (newV) {
        this.getData()
      }
    }
  },
  methods: {
    print () {
      this.$refs.print.print()
    },
    changeTab (tab) {
      this.tab = tab
    },
    formatTimeShow (time) {
      if (time) {
        return moment(time).format('YYYY-MM-DD HH:mm')
      } else {
        return '--'
      }
    },
    formatSHowNum (num) {
      return num.toString()
    },
    async getData () {
      await Promise.all([this.getStoreInfo(), this.getPointInfo()])
    },
    async getStoreInfo () {
      this.isRequestStore = true
      const [num1, num2] = await Promise.all([
        this.getStoreResults(this.time1),
        this.getStoreResults(this.time2)
      ])
      this.time1BugNum = num1.num
      this.time2BugNum = num2.num
      this.time1Store = num1.result
      this.time2Store = num2.result
      this.isRequestStore = false
    },
    async getPointInfo () {
      this.isRequestPoint = true
      const [point1, point2] = await Promise.all([
        this.getAllpointResults(this.time1),
        this.getAllpointResults(this.time2)
      ])
      this.time1points = point1
      this.time2points = point2
      this.isRequestPoint = false
    },
    async getStoreResults (date) {
      const res = await this.$tkParse.get('/classes/dayStoreResult', {
        params: {
          where: {
            store: this.storeId,
            date: {
              $gt: moment(date)
                .startOf('day')
                .toISOString(),
              $lte: moment(date)
                .endOf('day')
                .toISOString()
            }
          }
        }
      })
      let num
      if (res.data.results.length > 0) {
        num = res.data.results[0].bugNum
      } else {
        num = 0
      }
      return { num, result: res.data.results[0] }
    },
    // 获取对应日期下的点位数据
    async getAllPoint (date) {
      const resq = await this.$tkParse.get('/classes/dayStore', {
        params: {
          where: {
            originalId: this.storeId,
            date: {
              $gt: moment(date)
                .startOf('day')
                .toISOString(),
              $lte: moment(date)
                .endOf('day')
                .toISOString()
            }
          }
        }
      })
      let time = '17:00'
      if (resq.data.results.length > 0) {
        const times = resq.data.results[0].times.split('@')
        time = times[times.length - 1]
      }
      const res = await this.$tkParse.get('/classes/dayDrop', {
        params: {
          where: {
            store: this.storeId,
            date: {
              $gt: moment(date)
                .startOf('day')
                .toISOString(),
              $lte: moment(date)
                .endOf('day')
                .toISOString()
            }
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      return [res.data.results, time]
    },
    async getAllpointResults (date) {
      const [allPoint, timetag] = await this.getAllPoint(date)
      const promises = allPoint.map(element => {
        return this.$tkParse.get('/classes/testResults', {
          params: {
            where: {
              time: timetag,
              drop: element.originalId,
              date: {
                $gt: moment(date)
                  .startOf('day')
                  .toISOString(),
                $lte: moment(date)
                  .endOf('day')
                  .toISOString()
              }
            },
            limit: Number.MAX_SAFE_INTEGER
          }
        })
      })
      const res = await Promise.all(promises)
      return res.map((element, index) => {
        const res = element.data.results
        let result
        if (res.length > 0) {
          result = {
            hasResult: true,
            ...allPoint[index],
            point: `${allPoint.index}号点位`,
            count: res[0].bugNum,
            ...res[0]
          }
        } else {
          result = {
            hasResult: false,
            ...allPoint[index],
            point: `${allPoint[index].index}号点位`,
            count: 0
          }
        }
        return result
      })
    }
  },
  computed: {
    storeId () {
      return this.$route.query.store
    },
    isEmpty () {
      return (
        !this.isRequestStore &&
        !this.isRequestPoint &&
        this.maxPointLength === 0
      )
    },
    storeNumShow () {
      return this.time1BugNum - this.time2BugNum
    },
    width () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.length
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    height () {
      if (this.storeInfo.type === 'square') {
        return this.storeInfo.width
      } else if (this.storeInfo.type === 'circle') {
        return this.storeInfo.diameter / squareRoot2
      } else {
        return 0
      }
    },
    isCircle () {
      return this.storeInfo.type !== 'square'
    },
    maxPointLength () {
      return Math.max(this.time1points.length, this.time2points.length)
    },
    originalList () {
      let time1Arr = Array.from(this.time1points)
      let time2Arr = Array.from(this.time2points)
      if (this.maxPointLength > 0) {
        const time1index = time1Arr.length
        const time2index = time2Arr.length
        time1Arr.length = this.maxPointLength
        time2Arr.length = this.maxPointLength
        time1Arr.fill({ count: 0 }, time1index)
        time2Arr.fill({ count: 0 }, time2index)
      }
      return time1Arr.map((element, index) => ({
        num: index + 1,
        count: element.count - time2Arr[index].count,
        origin: {
          hasResult: true
        }
      }))
    }
  }
}
</script>
<style lang="scss" scoped>
.descriptions {
  ::v-deep .ant-descriptions-view {
    border-radius: 8px 8px 0 0;
    .ant-descriptions-item-label {
      font-weight: 600;
      text-align: center;
    }
    .ant-descriptions-item-content {
      text-align: center;
    }
  }
}
.custom-table {
  color: #363b45;
  text-align: center;
  .table-left {
    border-left: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
    width: 107px;
    flex-shrink: 0;
    div {
      padding: 8px 0;
      border-bottom: 1px solid #e8e8e8;
    }
  }
  .table-right {
    > div {
      border-right: 1px solid #e8e8e8;
      div {
        padding: 8px 0;
        border-bottom: 1px solid #e8e8e8;
      }
    }
  }
  .title {
    font-weight: 600;
    background: #fafafa;
  }
}
.report {
  background: #fff;
  .reportTitle {
    padding: 14px 0;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 16px;
      font-weight: 600;
    }
    .right {
      font-size: 12px;
    }
  }
}
.report {
  background: #fff;
  .reportTitle {
    padding: 14px 0;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 16px;
      font-weight: 600;
    }
    .right {
      font-size: 12px;
    }
  }
}
::v-deep .ant-card-body {
  padding: 0px;
}
.point-tag {
  width: 16px;
  height: 10px;
  border-radius: 2px;
  &.bug {
    background-color: #ee5729;
  }
  &.nobug {
    border: 1px solid #45eec4;
    background-color: #45eec4;
  }
  &.notest {
    background-color: #efeff0;
  }
}
.tabs div {
  position: relative;
}
.tabs div.active {
  color: #2fbf79;
}
.tabs div.active::after {
  content: "";
  position: absolute;
  width: 50%;
  height: 1px;
  background-color: #2fbf79;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
